import { render, staticRenderFns } from "./ClientProfileTab.vue?vue&type=template&id=3084fba2&scoped=true"
import script from "./ClientProfileTab.vue?vue&type=script&lang=ts"
export * from "./ClientProfileTab.vue?vue&type=script&lang=ts"
import style0 from "./ClientProfileTab.vue?vue&type=style&index=0&id=3084fba2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3084fba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3084fba2')) {
      api.createRecord('3084fba2', component.options)
    } else {
      api.reload('3084fba2', component.options)
    }
    module.hot.accept("./ClientProfileTab.vue?vue&type=template&id=3084fba2&scoped=true", function () {
      api.rerender('3084fba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/ClientProfileTab.vue"
export default component.exports